export default "/images/10357c7af85fd88bf6196350671607c9.avif";